// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"df1008fb","241":"72260a45","370":"5bbe52d1","500":"f84a12dd","618":"2e6dfb37","746":"0464544a"}[chunkId] + ".css";
};